<template>
  <VIcon
    v-bind="$attrs"
    v-on="$listeners"
  >
    mdi-{{ iconName }}
  </VIcon>
</template>

<script>
export default {
  name: 'StIcon',
  props: {
    iconName: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
